import { useUpdateCompanyLimits } from '@/hooks/useCompanyLimits';

interface Props {
  companyId: string;
}

/**
 *
 * Consumes a company view for the user.
 *
 */
export function UpdateCompanyLimits({ companyId }: Props) {
  useUpdateCompanyLimits(companyId);
  return null;
}
